module.exports = __webpack_public_path__ + "static/media/webIcons-30.da8043a8.svg";